<template>
    <div class="icon">
        <i class="fas fa-info-circle info-icon"></i>
        <div class="info-popup" :style="bodyStyle">
        <div class="arrow"></div>
            <header :style="headerStyle" v-if="title">{{title}}</header>
            <p>
                {{text}}
                <slot></slot>
            </p>
        </div>
    </div>
</template>

<script>
export default {
    props:{
        backgroundColor : { type : String, default: "#ffffff"},
        headerBg : { type : String, default: "#7367f0"},
        headerColor: { type : String, default: "#ffffff"},
        color : { type : String, default: "#6e6b7b"},
        title : { type : String, default: "title"},
        text : { type : String, default: "lorem ipsume"},
        
    },
    computed : {
        bodyStyle(){
            return {
                'background-color' : this.backgroundColor,
                color : this.color,

            }
        },
        headerStyle(){
            return {
                'background-color' : this.headerBg,
                color : this.headerColor,

            }
        }
    }
}
</script>

<style lang="scss" scoped>
    .icon {
        padding : 0 .5rem;
        position : relative;
        color: #9e9ca7;
    }
    .icon:hover > .info-popup{
        visibility: visible;
    }
    .info-popup {
        visibility: hidden;
        position: absolute;
        right: -220px;
        bottom: 27px;
        box-shadow: 0 0 10px 0 #22292f1a;
        width: 256px;
        z-index: 120;
        font-size: 1rem;
        border-radius: .3rem;
        user-select: none;
        line-height: 1.35;
        transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out, visibility 0.15s ease-in-out, background 0s, border 0s;
        p {
            font-weight: 400;
            padding: 0.65rem 1.21rem;
        }
        header {
            border-radius: .3rem .3rem 0 0 ;
            font-weight: 500;
            font-size: 1.1rem;
            width: 100%;
            padding: 0.65rem 1.21rem;

        }
    }
    .arrow {
        position: absolute;
        display: block;
        width: 1rem;
        height: 0.5rem;
        bottom: -0.5rem;
        left: 1.2rem;
        &:after,&:before {
            position: absolute;
            display: block;
            content: "";
            border-color: transparent;
            border-style: solid;
            border-top-color: #dddddd;
            border-width: 0.5rem 0.5rem 0;
        }
    }
    p{margin : 0}

</style>


// WEBPACK FOOTER //
// src/components/global/Popover.vue